export const meta = {
  title: 'அடிக்கடி கேட்கப்படும் கேள்விகள்',
  updatedAt: '2026-07-17',
  related: ['getting-started', 'troubleshooting'],
};

ஆபரேட்டர்கள் உண்மையில் கேட்கும் கேள்விகள், சுருக்கமான பதில்களுடன். ஒவ்வொன்றும் இந்தக் கையேட்டின் முழுமையான கட்டுரையைச் சுட்டுகிறது.

## தொடங்க எவ்வளவு நேரம் ஆகும்?

நிமிடங்கள்தான். பதிவு நான்கே புலங்கள், அட்டை தேவையில்லை; வரவேற்பு வழிகாட்டி உங்கள் கடை, நேரங்கள், லோகோவை அமைக்கிறது; **QR அச்சிடு** வாடிக்கையாளர்கள் ஸ்கேன் செய்யும் குறியீட்டைத் தருகிறது. முழு நடைப்பயணம் _தொடங்குதல்_ கட்டுரையில். முதல் 14 நாட்கள் முழு அணுகலுடன் இலவசச் சோதனை.

## வாடிக்கையாளர்கள் ஆப் பதிவிறக்க வேண்டுமா?

இல்லை. உங்கள் QR-ஐ ஸ்கேன் செய்தால் உங்கள் ஆப் உலாவியில் திறக்கும் — ஆப் ஸ்டோர் இல்லை, பதிவிறக்கம் இல்லை. நிறுவிய ஆப் போலச் செயல்பட முகப்புத் திரையில் _சேர்க்கலாம்_, ஆனால் சேர்க்காமலும் அனைத்தும் இயங்கும்.

## வாடிக்கையாளர்கள் யாருடைய பெயரைப் பார்க்கிறார்கள் — என்னுடையதா, நெட்வொர்க்கினுடையதா?

உங்களுடையது. உங்கள் பெயர், லோகோ, நிறங்கள். நெட்வொர்க் "நெட்வொர்க்கின் அங்கம்" என்ற சிறு வரியாக மட்டுமே தோன்றும். _பிராண்டிங்_ பாருங்கள்.

## சோதனைக் காலம் முடிந்தால் என்ன ஆகும்?

உங்கள் திட்டம் மாதாந்திரமாக, பின்-கட்டணமாகக் கணக்கிடத் தொடங்கும்: முடிந்த மாதத்தை உள்ளடக்கிய ஒரு இன்வாய்ஸ் 1ஆம் தேதிக்குச் சற்றுப் பின் வரும்; பில்லிங் பக்கத்திலிருந்து FPX மூலம் செலுத்தலாம். ஒவ்வொரு கட்டணமும் விரிவாகப் பிரிக்கப்பட்டுள்ளது — _பில்லிங்கும் உங்கள் சந்தாவும்_ பாருங்கள்.

## ஒரே கணக்கில் பல கடைகள் நடத்தலாமா?

ஆம். கடைகள் பக்கத்திலிருந்து சேர்க்கலாம்; ஒவ்வொன்றுக்கும் சொந்த வரிசையும் QR குறியீடும் உண்டு; உறுதிப்படுத்தும் முன் விகிதாசாரக் கட்டணம் முன்னோட்டமாகத் தெரியும். ஊழியர்களைக் கடை வாரியாக ஒதுக்கலாம்.

## நேரடியாக வரும் (walk-in) வாடிக்கையாளர்கள் புள்ளி பெறுவார்களா?

உள்நுழைந்த வாடிக்கையாளர்கள் மட்டுமே புள்ளி பெறுவார்கள் — வாடிக்கையாளர் கணக்கு இல்லாத walk-in டிக்கெட்டுக்கு எதுவும் இல்லை. வழக்கமான வாடிக்கையாளர்களை உங்கள் QR-ஐ ஸ்கேன் செய்யத் தூண்ட இதுவே சிறந்த காரணம். _விசுவாசம்_ பாருங்கள்.

## என் அறிவிப்பு ஏன் என் வாடிக்கையாளர் எண்ணிக்கையை விடக் குறைவானவர்களைச் சென்றடைந்தது?

மூன்று பாதுகாப்பு வாயில்கள்: மார்க்கெட்டிங் விலகல்கள், அமைதி நேரங்கள், அறிவிப்புகளை ஒருபோதும் அனுமதிக்காத வாடிக்கையாளர்கள். அனுப்புதல் சுருக்கம் ஒவ்வொரு பிரிவையும் பெயரிடுவதால் இடைவெளி ஒருபோதும் மர்மமல்ல. _மார்க்கெட்டிங் அறிவிப்புகள்_ பாருங்கள்.

## முகவர் குறியீட்டைப் பயன்படுத்த எனக்கு ஏதேனும் செலவாகுமா?

இல்லை. குறியீடு இருந்தாலும் இல்லாவிட்டாலும் விலை ஒன்றே. முகவர் ஒவ்வொரு பதிவுக்கும் ஒருமுறை மட்டுமான கமிஷனை நெட்வொர்க்கின் தரப்பிலிருந்து பெறுகிறார் — உங்கள் பில்லிலிருந்து ஒருபோதும் அல்ல. _முகவர் குறியீடுகளும் பரிந்துரைகளும்_ பாருங்கள்.

## முன்பதிவின்றி வாடிக்கையாளர்கள் என் விலைகளைப் பார்க்கலாமா?

ஆம் — உங்கள் தொகுப்புகள், கூடுதல்கள், விலைகள் உங்கள் ஆப்பில் பொதுவானவை. உங்கள் இணைப்போ QR-ஓ கிடைத்த எவரும் முடிவெடுக்கும் முன் பட்டியலை உலாவலாம்.

## தளம் எந்த மொழிகளில் பேசுகிறது?

டாஷ்போர்டு, உங்கள் வாடிக்கையாளர் ஆப், இந்தக் கையேடு — English, Bahasa Melayu, 中文, தமிழ் ஆகியவற்றில் இயங்குகின்றன; வாடிக்கையாளர்கள் ஆப்பில் மொழியைத் தேர்வுசெய்கிறார்கள். ஒரு நேர்மையான இடைவெளி: புஷ் அறிவிப்பு உரை தற்போது ஆங்கிலத்தில் நிலையானது. _அறிவிப்புகள்_ பாருங்கள்.

## ஒவ்வொரு ஊழியருக்கும் தனி உள்நுழைவு உண்டா?

ஆம். ஊழியர்கள் பக்கத்திலிருந்து தொலைபேசி எண் மூலம் அழையுங்கள்; அவர்கள் ஒருமுறை குறியீட்டால் உள்நுழைவார்கள் — நிர்வகிக்கக் கடவுச்சொற்கள் இல்லை. பாத்திரங்கள் (மேலாளர், காசாளர், கழுவுபவர்) ஒவ்வொருவரும் தொடக்கூடியதைத் துல்லியமாகக் கட்டுப்படுத்துகின்றன. _ஊழியர்களும் பாத்திரங்களும்_ பாருங்கள்.

## பொது தேடல் அடைவில் எப்படி இடம்பெறுவது?

நேரங்கள் பக்கத்தின் அடியிலுள்ள **என் கடைகளைப் பொது அடைவில் காட்டு** என்பதை இயக்குங்கள். அது இயல்பாக அணைந்துள்ளது — யாரும் தாமே தேர்வுசெய்யாமல் பட்டியலிடப்படுவதில்லை. இயக்கியும் தோன்றவில்லை என்றால், _சிக்கல் தீர்வு_ கட்டுரையில் சரிபார்ப்புப் பட்டியல் உள்ளது.
